export const SPARKLE_FILLED_PATH =
  'M15.987 9.36 23 12l-7.013 2.639L13.29 21.5l-2.699-6.861L3.58 12l7.012-2.64L13.29 2.5l2.697 6.86ZM5.189 19.068H3v-1.285h2.19V15.64h1.313v2.142h2.189v1.285h-2.19v2.142H5.19v-2.142Zm0-12.85H3V4.931h2.19V2.79h1.313v2.142h2.189v1.285h-2.19V8.36H5.19V6.217Z';
